import SVM from "libsvm-js/asm";
import { CLASSIFICATION_MODELS } from "../constants";
import { infoType } from "./Dataset";
import { SupportVectorMachine } from "./SupportVectorMachine";

export class LogisticRegression extends SupportVectorMachine {
  modelName = CLASSIFICATION_MODELS.logistic;

  constructor(mlDataInfo: infoType) {
    super(mlDataInfo);
    this.paramGrid = {
      cost: [0.1, 1, 10, 100],
      gamma: [0],
      epsilon: [0],
    };
    this.svm_type = SVM.SVM_TYPES.C_SVC;
    this.probabilityEstimates = true;
  }

  initModel(gamma: number, cost: number, epsilon: number): SVM {
    return new SVM({
      kernel: SVM.KERNEL_TYPES.LINEAR, // The type of kernel I want to use
      type: this.svm_type, // The type of SVM I want to run
      cost: cost, // C_SVC cost parameter
      epsilon: epsilon,
      quiet: true,
      tolerance: 0.01,
      probabilityEstimates: this.probabilityEstimates,
      weight: this.mlDataInfo.weights,
    });
  }
}
